import React, { FC } from 'react';
import { Text } from '../../../Text';
import { DATA_HOOK } from '../../ListItemAction.constants';
import { classes, st } from '../../ListItemAction.st.css';
import { ListItemActionProps } from '../../ListItemAction.types';

type ListItemActionSuffixProps = Pick<
  ListItemActionProps,
  'suffix' | 'size' | 'ellipsis' | 'disabled'
>;

export const Suffix: FC<ListItemActionSuffixProps> = ({
  suffix,
  size,
  ellipsis,
  disabled,
}) => {
  return (
    <div className={st(classes.textOverrides, { size }, classes.suffixBox)}>
      <Text
        className={classes.suffix}
        dataHook={DATA_HOOK.suffix}
        secondary
        size={size}
        light={!disabled}
        weight="thin"
        skin={disabled ? 'disabled' : 'standard'}
        ellipsis={ellipsis}
      >
        {suffix}
      </Text>
    </div>
  );
};
